import React from 'react';

import { CameraOffIcon } from '@vlabs/icons';
import { usePageContext } from '@vlabs/monokit/shared/ui/page';
import { Control } from '@vlabs/uikit';

import { useSourceLivePageTranslation } from '../i18n';
import { useRestream } from '../restream-context';
import st from './StreamErrorStub.module.sass';

interface StreamErrorStubProps {
  /** С кнопкой переподключения («Видео недоступно») или без («Трансляция не поддерживается»). */
  withReconnect?: boolean;
}

// Заглушки по макетам: «Видео недоступно» с кнопкой переподключения
// и «Трансляция не поддерживается» без кнопки.
function StreamErrorStub({
  withReconnect = false,
}: StreamErrorStubProps): React.JSX.Element {
  const { t } = useSourceLivePageTranslation();
  const { reconnect } = useRestream();
  const pageCtx = usePageContext();

  let description = t('unsupported_type');
  if (withReconnect) {
    description = t('try_later_or_reconnect');
  }

  return (
    <div className={st.Root}>
      <div className={st.Icon}>
        <CameraOffIcon />
      </div>
      <div className={st.Text}>
        <p className={st.Title}>{t('video_unavailable')}</p>
        <p className={st.Description}>{description}</p>
      </div>
      {!!withReconnect && (
        <Control.Button
          data-testid="stream-reconnect"
          kind="primary"
          onClick={reconnect}
          size={pageCtx.buttonSize}
        >
          {t('connect')}
        </Control.Button>
      )}
    </div>
  );
}

export { StreamErrorStub };
